.textarea {
  resize: none;
  background-color: var(--vkui--color_background_secondary);
  border-radius: 12px;
  width: 100%;
  overflow-y: auto;
  max-height: 150px;
  height: 0;
  min-height: 44px;
  box-sizing: border-box;
  padding: 12px;
  margin: 10px 0;
  border: 0 none;
  font-family: var(--vkui--font_text--font_family--compact, var(--vkui--font_text--font_family--regular));
  font-size: var(--vkui--font_text--font_size--compact, var(--vkui--font_text--font_size--regular));
  font-weight: var(--vkui--font_text--font_weight--compact, var(--vkui--font_text--font_weight--regular));
  line-height: var(--vkui--font_text--line_height--compact, var(--vkui--font_text--line_height--regular));
  scrollbar-color: var(--vkui--color_icon_tertiary_alpha) transparent;
  scrollbar-width: thin;
}

.textarea:focus {
  border: 0 none;
  outline: none; /* так делать плохо */
}

.beforeNode {
  margin-bottom: 18px;
  height: 28px;
}

.afterNode {
  margin-bottom: 18px;
  height: 28px;
}
